import { authApi } from '@api/auth/auth.api';

export const {
  useLoginMutation,
  useRegistrationMutation,
  useLazySsoQuery,
  useCallbackMutation,
  useResetPasswordMutation,
  useNewPasswordMutation,
  useLoginMfaMutation,
  useVerifyUserMutation,
  useResendVerifyMutation,
} = authApi;
